<template>
  <v-card
    class="mx-auto"
    v-if="article"
  >
    <v-img :src="article.photo"
      height="200px" />
    <v-btn
      v-if="selectedArticle > 0"
      small icon color="primary" style="position: absolute; top: 25%;"
      @click="previousArticle">
      <v-icon dark>{{ mdiChevronLeft }}</v-icon>
    </v-btn>
    <v-btn
      v-if="selectedArticle < (articles.length - 1)"
      small icon color="primary" style="position: absolute; top: 25%; right: 0;"
      @click="nextArticle">
      <v-icon dark>{{ mdiChevronRight }}</v-icon>
    </v-btn>
    <v-card-title style="word-break: break-word">
      {{ article[`title${localePostFix}`] }}
    </v-card-title>

    <v-card-subtitle style="word-break: break-word">
      {{ article[`subTitle${localePostFix}`] }}
      <span class="d-block text-right text-caption">
        {{ $t('Membership.Article.published') }}: {{ formatDateTime(article.created) }}
      </span>
    </v-card-subtitle>
    <v-card-actions>
      <v-btn
        color="orange lighten-2"
        @click="show = !show"
        text
      >
        {{ $t('common.more') }}
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        icon
        @click="show = !show"
      >
        <v-icon>{{ show ? mdiChevronUp : mdiChevronDown }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>

        <v-card-text v-html="article[`body${localePostFix}`]" />
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import {
  mdiChevronUp, mdiChevronDown, mdiChevronLeft, mdiChevronRight,
} from '@mdi/js';

export default {
  name: 'Article',
  props: ['articles', 'loading'],
  data() {
    return {
      selectedArticle: this.articles?.length - 1,
      show: false,
      mdiChevronLeft,
      mdiChevronUp,
      mdiChevronDown,
      mdiChevronRight,
    };
  },
  computed: {
    article() {
      return this.articles[this.selectedArticle];
    },
    localePostFix() {
      const { locale } = this.$i18n;
      const postFix = locale.charAt(0).toUpperCase() + locale.slice(1);
      return postFix;
    },
  },
  mounted() {
    this.selectedArticle = this.articles?.length - 1;
  },
  methods: {
    nextArticle() {
      if (this.selectedArticle < (this.articles?.length - 1)) {
        this.selectedArticle += 1;
      }
    },
    previousArticle() {
      if (this.selectedArticle > 0) {
        this.selectedArticle -= 1;
      }
    },
  },
  watch: {
    articles: {
      immediate: true,
      deep: true,
      handler() {
        this.selectedArticle = this.articles?.length - 1;
      },
    },
  },
};
</script>
